@use "../../styles/breakpoint.module.scss" as *;

.content {
    > * {
        margin-block: var(--spacer-16);

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    a {
        margin-top: var(--spacer-16);
    }
}

.eyebrow {
    composes: fontEyebrow from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-24);

    @media ($above-mobile) and ($below-tablet) {
        margin-bottom: var(--spacer-16);
    }
}

.title {
    composes: fontHeader34 from "../../styles/composable/typography.module.css";
}
